import { Modal, Form, Row, Col, Input, Button } from "antd";
import { useModalCodigos } from "../../../hooks/useModalCodigos";

interface IModalCodigos {
  openModal: boolean;
  setOpenModal: Function;
}

export const ModalCodigos = ({
  openModal,
  setOpenModal
}: IModalCodigos): any => {
  const {
    actualizarCodigo,
    setCodigoPropuesta,
    codigoPropuesta,
    numeroDocumento,
    setNumeroDocumento,
    nuevoCodigo
  } = useModalCodigos()

  const fields = [
    { name: "codigoPropuesta", value: codigoPropuesta },
    { name: "numeroDocumento", value: numeroDocumento },
  ];

  const handleInputChangeCodigo = (e) => {
    setCodigoPropuesta(e.target.value);
  };

  const handleInputChangeId = (e) => {
    setNumeroDocumento(e.target.value);
  };

  // @ts-ignore
  return (
    <Modal
      maskStyle={{
        backgroundColor: "rgba(31,174,239,0.8)",
        borderRadius: "6px",
      }}
      title="Gestionar códigos repetidos"
      visible={openModal}
      onCancel={() => setOpenModal(!openModal)}
      width={window.innerWidth * 0.5}
      footer={
        <Row justify="end" gutter={[24, 24]}>
          <Col>
            <Button
              className="button-gray-ghost"
              onClick={() => window.location.reload()}
            >
              Cerrar
            </Button>
          </Col>
          <Col className="justify-content-flex-end">
            <Button
              className="button-azul-radius"
              htmlType="submit"
              form="modalCodigos"
            >
              Actualizar código
            </Button>
          </Col>
        </Row>
      }
    >
      <Form
        fields={fields}
        name="modalCodigos"
        onFinish={() => actualizarCodigo()}
      >
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Form.Item
              className="no-margin"
              name="codigoPropuesta"
              rules={[{ required: true, message: "" }]}
            >
              <Input onChange={handleInputChangeCodigo} placeholder="Código de propuesta" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              className="no-margin"
              name="numeroDocumento"
              rules={[{ required: true, message: "" }]}
            >
              <Input onChange={handleInputChangeId} placeholder="Número de documento" />
            </Form.Item>
          </Col>
          <br />
          { nuevoCodigo && (
            <div>
              Se actualiza código repetido <span style={{fontWeight: 'bold'}}>{codigoPropuesta}</span> con número de documento: <span style={{fontWeight: 'bold'}}>{numeroDocumento}</span> por el nuevo código de propuesta: <span style={{fontWeight: 'bold'}}>{nuevoCodigo}</span>
            </div>
          )}
        </Row>
      </Form>
    </Modal>
  );
};
